import { Button } from "@/shared/components";
import { TableRegular } from "@/shared/components/Icons";
import NetLogicCartItem from "@/shared/containers/Cart/NetLogicCartItem";

import styles from "@/styles/containers/command.module.scss";

export default function NetLogicCart({
  myItems,
  otherItems,
  activeTab,
  goToCatalog,
}) {
  const renderCartItems = () => {
    return (
      <NetLogicCartItem
        order={activeTab === "Pedidos por você" ? myItems : otherItems}
      />
    );
  };

  const items = activeTab === "Pedidos por você" ? myItems : otherItems;
  if (!items) return null;

  return (
    <>
      {!myItems?.length && activeTab === "Pedidos por você" && (
        <div className={styles.empty}>
          <div className={styles.icon}>
            <TableRegular />
          </div>

          <p>Você ainda não fez pedidos.</p>
          <span>
            O que acha de ver o nosso cardápio e experimentar uma das nossas
            opções?
          </span>

          <Button design="primary" onClick={goToCatalog}>
            Ver cardápio
          </Button>
        </div>
      )}

      {!otherItems?.length && activeTab !== "Pedidos por você" && (
        <div className={styles.empty}>
          <div className={styles.icon}>
            <TableRegular />
          </div>

          <p>Não há nenhum outro pedido feito na mesa.</p>
          <span>
            O que acha de ver o nosso cardápio e experimentar uma das nossas
            opções?
          </span>
        </div>
      )}

      {items.length > 0 && renderCartItems()}
    </>
  );
}
